import cx from 'classnames';

import { GlossIcon } from 'glossDS/Icons/GlossIcon/GlossIcon';

import { useCart } from 'hooks/cart/useCart';

import { BAG } from './BagCounter.dictionary';

import styles from './BagCounter.module.css';

type Props = {
  className?: string;
  size?: number;
  textOnly?: boolean;
};

export const BagCounter = ({
  size = 24,
  className,
  textOnly = false,
}: Props) => {
  const { getTotalItemCount } = useCart();

  const itemsCount = getTotalItemCount();
  const hasItems = itemsCount > 0;

  if (textOnly) {
    return <>{BAG(itemsCount)}</>;
  }

  return (
    <div className={cx(styles.wrapper, className)}>
      <GlossIcon
        className={styles.icon}
        icon="shopping-bag-4-line"
        size={size}
      />
      {hasItems && <span className={styles.counter}>{itemsCount}</span>}
    </div>
  );
};
